export const DOMAIN = 'notificationList';
